<template>
  <div>
    <!--보도자료 검색결과 시작-->
    <section class="search-result-wrap">
      <div class="search-result">
        <em>{{ $t('press.name') }}</em> {{ $t('search.result') }} <em class="count">{{ count.report }}</em> {{ $t('search.unit') }}
      </div>

      <div class="search-result-content">
        <list-component
          type="report"
          date="DistributeDay"
          page-query="report"
          :size="5"
          :keyword="$route.query.word"
          :prev-route="prevRoute"
          @countChang="changeCount"
          @prevRouteUpdate="prevRouteUpdate"
        />
      </div>
    </section>
    <!--보도자료 검색결과 끝-->

    <!--언론보도 검색결과 시작-->
    <section class="search-result-wrap">
      <div class="search-result">
        <em>{{ $t('release.name') }}</em> {{ $t('search.result') }} <em class="count">{{ count.media }}</em> {{ $t('search.unit') }}
      </div>
      <div class="search-result-content">
        <list-component
          type="media"
          date="ReportDay"
          page-query="media"
          :size="5"
          :keyword="$route.query.word"
          :prev-route="prevRoute"
          @countChang="changeCount"
          @prevRouteUpdate="prevRouteUpdate"
        />
      </div>
    </section>
    <!--언론보도 검색결과 끝-->

    <!--팩트 바로알기 검색결과 시작-->
    <section class="search-result-wrap">
      <div class="search-result">
        <em>{{ $t('factCheck.name') }}</em> {{ $t('search.result') }} <em class="count">{{ count.fact }}</em> {{ $t('search.unit') }}
      </div>

      <list-component
        type="fact"
        date="PublishDate"
        page-query="fact"
        :size="5"
        :keyword="$route.query.word"
        :prev-route="prevRoute"
        @countChang="changeCount"
        @prevRouteUpdate="prevRouteUpdate"
      />

      <div v-if="!count.report && !count.media && !count.fact" class="search-result-content nodata">
        <div class="search-nodata">
          {{ $t('search.nodata') }}
        </div>
      </div>
    </section>
    <!--팩트 바로알기 검색결과 끝-->
  </div>
</template>
<script>
export default {
  components: {
    listComponent: () => import('@/components/base/NewsroomList'),
  },
  props: {
    tabList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      count: {
        report: 0,
        media: 0,
        fact: 0
      },
      prevRoute: null
    }
  },
  created () {
/*
    if (this.$route.query.word) {
      this.query = this.$route.query
      console.log(this.query.word)
      this.getSearchReport({ word: this.query.word, page: this.query.report })
      this.getSearchMedia({ word: this.query.word, page: this.query.media })
      this.getSearchFact({ word: this.query.word, page: this.query.fact })
    }
*/
  },
  methods: {
    // http://localhost:8081/api/report?language=KR&pageNumber=1&pageSize=10&searchKeyword=a&searchType=TITLE_CONTENT
/*    async getSearchReport (options) {
      console.log('getSearchReport', options)
      const { data } = await newsroomApi.getReport({
        pageNumber: 1,
        pageSize: 3
      })

      this.mediaList = data.list
    },
    async getSearchMedia (options) {
      console.log('getSearchMedia', options)
    },
    async getSearchFact (options) {
      console.log('getSearch', options)
    }, */
    search () {

    },
    prevRouteUpdate (value) {
      this.prevRoute = value
    },
    changeCount (v) {
      this.count[v.type] = v.size
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from.name
    })
  }
}
</script>
